import { createRouter, createWebHistory } from 'vue-router'
// import AllProjects from '../views/AllProjects.vue'
import store from '../store'
import api from '../tools/api';
import { toast } from 'vue-sonner'

// When a user's subscription is invalid (canceled / unpaid / incomplete_expired,
// i.e. past the grace period), platform access is restricted: they may ONLY reach
// these routes (My Account + the upgrade flow + the public/auth pages). Add a
// route NAME here to widen the allow-list. Users WITHOUT a subscription are never
// gated, so this never affects free / manual-credit accounts.
const SUBSCRIPTION_ALLOWED_ROUTES = [
  'My dashboard space',   // '/'        → myAccount.vue
  'My Account',           // '/myaccount'
  'Upgrade your plan',    // '/upgrade_your_plan'
  'login',
  'unauthorize',
  'unauthorize_access',
  'Data policy',
  'Terms and Conditions',
  'Confirm your account',
]



const routes = [
  {
    path: '/',
    name: 'My dashboard space',
      component: () => import('../views/myAccount.vue'),

  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '../views/login.vue')
  },
  {
    path: '/list_filters',
    name: 'Matching filters - Personalize your selection criteria',

    component: () => import(/* webpackChunkName: "about" */ '../views/ListMyFilters.vue'),
          meta: {
        droit_access_required: [ "full"]
      }
  },
  {
    path: '/link_plus',
    name: 'My Link+ space - Generate your invitations',

    component: () => import(/* webpackChunkName: "about" */ '../views/GenerateLinkPlus.vue'),
          meta: {
            //tous le monde y a access mais pas tous peuvent valider 
      }
  },
  {
    path: '/list_link_plus',
    name: 'My Link+ space - View all invitations',

    component: () => import(/* webpackChunkName: "about" */ '../views/ListLinkPlus.vue'),
          meta: {
        droit_access_required: [ "full","scouting","pearlai_and_scouting"]
      }
  },
  {
    path: '/my_shared_lists',
    name: 'My shared startup lists',
    component: () => import(/* webpackChunkName: "about" */ '../views/ListSharedStartups.vue'),
    meta: {
      droit_access_required: [ "full","scouting","pearlai_and_scouting"]
    }
  },
  {
    path: '/manage_link_plus/:lid',
    name: 'Manage my Link+',

    component: () => import(/* webpackChunkName: "about" */ '../views/ManageLinkPlus.vue')
  },
  {
    path: '/my_link_plus/:aid',
    name: 'Innovator Application',

    component: () => import(/* webpackChunkName: "about" */ '../views/ViewLinkPlusPublic.vue'),
                //tous le monde y a access mais pas tous peuvent valider 

  },
 
  {
    path: '/startup_with_filters/:search_field/:pid',
    name: 'List innovators and filters',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupsListWithFilter.vue'),
          meta: {
        droit_access_required: [ "full"]
      }
  },
  {
    path: '/new_startup_with_filters/:search_field/:pid/:pool',
    name: 'My innovator list',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewStartupsListWithFilter.vue'),
          meta: {
        droit_access_required: [ "full"]
      }
  },
  {
    path: '/my_pools/:search_field/:pid/',
    name: 'My lists of candidates',

    component: () => import(/* webpackChunkName: "about" */ '../views/PoolsList.vue'),
          meta: {
        droit_access_required: [ "full"]
      }
  },
  {
    path: '/startup_with_filters_graph',
    name: 'List innovators and filters - Graph view',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupsListWithFilterGraph.vue'),
          meta: {
        droit_access_required: [ "full"]
      }
  },
  {
    path: '/startup_with_filters_graph/:search_field/:filterstoapply/:pid',
    name: 'List innovators and filters - Graph view - Prefilter',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupsListWithFilterGraph.vue'),
          meta: {
        droit_access_required: [ "full"]
      }
  },
  {
    path: '/view_filter/:filter',
    name: 'View and edit a filter',

    component: () => import(/* webpackChunkName: "about" */ '../views/ViewFilter.vue'),
          meta: {
        droit_access_required: [ "full","scouting",'pearlai_and_scouting']
      }
  },
  {
    path: '/myaccount',
    name: 'My Account',

    component: () => import(/* webpackChunkName: "about" */ '../views/myAccount.vue'),

  },
  {
    path: '/upgrade_your_plan',
    name: 'Upgrade your plan',

    component: () => import(/* webpackChunkName: "about" */ '../views/UpgradeYourPlan.vue'),
  },
  {
    path: '/create_your_account',
    name: 'Create your account',

    component: () => import(/* webpackChunkName: "about" */ '../views/CreateYourAccount.vue'),
    meta: { public_availability: true },
  },
  {
    path: '/startups_ecosystem',
    name: 'My ecosystem',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupsEcosystem.vue'),
          meta: {
        droit_access_required: [ "full","scouting",'pearlai_and_scouting']
      }
  },
  {
    path: '/startups_stats',
    name: 'My dashboard',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupsStats.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/startups_stats_list/:filterstoapply',
    name: 'List of innovators filtered',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupsStatsList.vue'),
     meta: {
        droit_access_required: [ "full"]
      }
  },
  {
    path: '/register',
    name: 'register',

    component: () => import(/* webpackChunkName: "about" */ '../views/register.vue'),
    meta: { roleRestriction: 'Admin'}
  },
  {
    path: '/register_admin',
    name: 'registerAdmin',

    component: () => import(/* webpackChunkName: "about" */ '../views/register_admin.vue'),

    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/all_projects',
    name: 'AllProjectsAdmin',

    component: () => import(/* webpackChunkName: "about" */ '../views/admin/list_adminprojects.vue'),

    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/all_startups',
    name: 'AllStartupsInDB',

    component: () => import(/* webpackChunkName: "about" */ '../views/admin/StartupsEcosystemAdmin.vue'),

    meta: {roleRestriction: 'Admin'}
  },

  {
    path: '/admin/partial_startups',
    name: 'PartialStartups',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/ListPartialStartups.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/expert/my_projects',
    name: 'Expert - All my projects',
    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertProjectsList.vue'),
    meta: {roleRestriction: 'Expert'}
  },
  {
    path: '/admin/my_projects',
    name: 'Admin - All my projects',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminProjectsList.vue'),
    meta: {roleRestriction: 'Admin'}
  },

  {
    path: '/admin/manage_users',
    name: 'Admin - Manage users',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminManageUsers.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/manage_users_admin',
    name: 'Admin - Manage admin users',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminManageUsersAdmin.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/manage_plan',
    name: 'Admin - Manage plans',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/ManagePlan.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/project/:id',
    name: 'Admin Project',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminOneProject.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
  path: '/expert/project/:id',
  name: 'Expert One Project dash',
  component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertOneProject.vue'),
  meta: {roleRestriction: 'Expert'}
},
  {
    path: '/admin/business_challenge/:projectid',
    name: 'Admin Business Challenge',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/businessChallengeAdmin.vue'),
    meta: {roleRestriction: 'Admin'}
  },

  {
    path: '/expert/business_challenge/:projectid',
    name: 'Review and sharp Business Challenge',
    component: () => import(/* webpackChunkName: "about" */ '../views/expert/businessChallengeExpert.vue'),
    meta: {roleRestriction: 'Expert'}
  },
  {
    path: '/admin/dict',
    name: 'dictAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/dictView.vue'),
     meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/reopen_assessment',
    name: 'reopenAssessment',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/reopenAssessment.vue'),
     meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/register_confirm/:id',
    name: 'Confirm your account',

    component: () => import(/* webpackChunkName: "about" */ '../views/registerConfirm.vue')
  },
  {
    path: '/selectYourChallenge',
    name: 'Select your challenge',

    component: () => import(/* webpackChunkName: "about" */ '../views/SelectChallengeView.vue'),
    meta: {
      droit_access_required: [ "full"]
    }
  },

  {
    path: '/project_init/:projectid',
    name: 'Intialize your project info',

    component: () => import(/* webpackChunkName: "about" */ '../views/QuickProjectCreation.vue'),
    meta: {
      droit_access_required: [ "full"]
    }
  },
  {
    path: '/business_challenge_space',
    name: 'Business Challenge Space',

    component: () => import(/* webpackChunkName: "about" */ '../views/BusinessChallengeSpace.vue'),
    meta: {
      droit_access_required: [ "full"]
    }
  },
  {
    path: '/business_challenge_space/:projectid',
    name: 'Business Challenge Space',

    component: () => import(/* webpackChunkName: "about" */ '../views/BusinessChallengeSpace.vue'),
     meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/scouting_space/:search_field_id/:projectid',
    name: 'Scouting Space',

    component: () => import(/* webpackChunkName: "about" */ '../views/ScoutingSpace.vue'),
    meta: {
      droit_access_required: [ "full"]
    }
  },
  {
    path: '/admin/scouting_brief/:search_field_id/:projectid',
    name: 'Admin scouting brief',

    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminScoutingBrief.vue'),

    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/expert/scouting_brief/:search_field_id/:projectid',
    name: 'Expert scouting brief',

    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertScoutingBrief.vue'),

    meta: {roleRestriction: 'Expert'}
  },
  {
      path: '/expert/scouting_brief_complete/:search_field_id/:projectid',
    name: 'Expert complete scouting brief',

    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertScoutingBriefComplete.vue'),

    meta: {roleRestriction: 'Expert'}
  },
  {
      path: '/admin/scouting_brief_complete/:search_field_id/:projectid',
    name: 'admin complete scouting brief',

    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminScoutingBriefComplete.vue'),

    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/candidatespool/:search_field_id/:projectid',
    name: 'Admin candidates pools management',

    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminCandidatePool.vue'),

    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/expert/candidatespool/:search_field_id/:projectid',
    name: 'Expert candidates pools management',

    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertCandidatePool.vue'),
   
    meta: {roleRestriction: 'Expert'}
  },
  {
    path: '/admin/startup_alt/:id',
    name: 'Admin - Manage innovator profile',
 
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminStartup.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/admin/startup/:id/:projectid',
    name: 'Admin innovator basic info',
 
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminStartup.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/expert/startup/:id/',
    name: 'Expert Innovators info',

    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertStartup.vue'),
    meta: {roleRestriction: 'Expert'}
  },
  {
    path: '/expert/startup/:id/:projectid',
    name: 'Expert innovator basic info',
  
    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertStartup.vue'),
    meta: {roleRestriction: 'Expert'}
  },
  {
    path: '/expert/startup_info/:id/:projectid',
    name: 'Expert innovator basic info when submit',

    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertStartupInfo.vue'),
    meta: {roleRestriction: 'Expert'}
  },
  {
    path: '/expert/assessment/:search_field_id/:projectid',
    name: 'Expert Assessment space',

    component: () => import(/* webpackChunkName: "about" */ '../views/expert/ExpertAssessment.vue'),
    meta: {roleRestriction: 'Expert'}
  },
  {
    path: '/admin/assessment/:search_field_id/:projectid',
    name: 'Admin Assessment space',

    component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminAssessment.vue'),
    meta: {roleRestriction: 'Admin'}
  },
  {
    path: '/all_my_projects',
    name: 'All my projects',

    component: () => import(/* webpackChunkName: "about" */ '../views/AllProjects.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/projet/:id',
    name: 'My project',

    component: () => import(/* webpackChunkName: "about" */ '../views/OneProject.vue'),
    meta: {
        droit_access_required: [ "full"]
  }
  },
  {
    path: '/candidatespool/:search_field_id/:projectid',
    name: 'Candidates pool',

    component: () => import(/* webpackChunkName: "about" */ '../views/CandidatePool.vue'),
          meta: {
        droit_access_required: [ "full","scouting","pearlai_and_scouting"]
      }
  },
  {
    path: '/startup/:id/:projectid',
    name: 'Innovator basic info',
    component: () => import(/* webpackChunkName: "about" */ '../views/StartupInfoBase.vue')
  },
  {
    path: '/startup/:id',
    name: 'Innovator profile',
 
    component: () => import(/* webpackChunkName: "about" */ '../views/StartupInfoBase.vue'),
  },
    {
    path: '/startup_public/:id/:listid/:token',
    name: 'Innovator profile shared',
 
    component: () => import(/* webpackChunkName: "about" */ '../views/StartupInfoPublicAccess.vue'),
  },
  {
    path: '/startup_report/:searchfield/:startup/:projectid',
    name: 'Innovator Info',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupInfo.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/sharedList/:listId/:token',
    name: 'Shared startup list',
    component: () => import(/* webpackChunkName: "about" */ '../views/SharedList.vue'),
  },
  {
    path: '/assessment/:searchfield/:projectid',
    name: 'Assessment',

    component: () => import(/* webpackChunkName: "about" */ '../views/AssessmentSpace.vue'),
    meta: {
      droit_access_required: [ "full"]
    }
  },
  {
    path: '/compare_startup/:searchfield/:a/:b/:projectid',
    name: 'Compare innovators',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupCompare.vue'),
    meta: {
        droit_access_required: [ "full"]
     }
  },
  {
    path: '/compare_startup_to_assess/:searchfield/:a/:b/:c?',
    name: 'Compare innovators to assess',

    component: () => import(/* webpackChunkName: "about" */ '../views/StartupBasicCompare.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/my_candidate_selection/:sid/:pid',
    name: 'My Candidate Selection',

    component: () => import(/* webpackChunkName: "about" */ '../views/SearchFieldSummary.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/summary/:pid',
    name: 'My project summary',

    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectSummary.vue'),
    meta: {
      droit_access_required: [ "full"]
    }
  },
  {
    path: '/unauthorize',
    name: 'unauthorize',

    component: () => import(/* webpackChunkName: "about" */ '../views/unauthorize.vue')
  },
    {
    path: '/unauthorize_access',
    name: 'unauthorize_access',

    component: () => import(/* webpackChunkName: "about" */ '../views/unauthorizeAccess.vue')
  },
  {
    path: '/manage_startup_info/:sid',
    name: 'Manage my innovator profile',

    component: () => import(/* webpackChunkName: "about" */ '../views/PublicAdminStartup.vue'),

  },


  {
    path: '/internalassessment_creation/:id?',
    name: 'Create an internal assessment',

    component: () => import(/* webpackChunkName: "about" */ '../views/InternalAssessmentCreation.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/internalassessment_judge_links/:id?',
    name: 'View judges\' links',

    component: () => import(/* webpackChunkName: "about" */ '../views/InternalAssessmentJudgesLink.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },
  {
    path: '/internalassessment_preview/:id',
    name: 'Preview an internal assessment',

    component: () => import(/* webpackChunkName: "about" */ '../views/InternalAssessmentPreview.vue'),
    meta: {
        droit_access_required: [ "full"]
    }
  },

    {
      path: '/judge_assessment/:token/:id',
      name: 'Judge assessment',
  
      component: () => import(/* webpackChunkName: "about" */ '../views/JudgeAssessment.vue')
    },
    {
      path: '/judge_vote/:token/:id/:sid',
      name: 'Judge - Assess the innovator',

      component: () => import(/* webpackChunkName: "about" */ '../views/JudgeAssessStartup.vue')
    },
    {
      path: '/admin/manage_data_policy',
      name: 'Manage data policy',

      component: () => import(/* webpackChunkName: "about" */ '../views/admin/DataPolicy.vue'),
            meta: {roleRestriction: 'Admin'}
    },
    {
      path: '/datapolicy',
      name: 'Data policy',

      component: () => import(/* webpackChunkName: "about" */ '../views/DataPolicyPublic.vue'),
    },
    {
      path: '/terms_and_conditions',
      name: 'Terms and Conditions',
  
      component: () => import(/* webpackChunkName: "about" */ '../views/TermsAndConditionsPublic.vue'),

    },

    {
      path: '/admin/manage_terms_and_conditions',
      name: 'Manage terms and conditions',

      component: () => import(/* webpackChunkName: "about" */ '../views/admin/TermsAndConditions.vue'),
            meta: {roleRestriction: 'Admin'}
    },
    {
      path: '/admin/manage_default_data/:dataid',
      name: 'Manage default datas',

      component: () => import(/* webpackChunkName: "about" */ '../views/ManageDefaultDatas.vue'),
            meta: {roleRestriction: 'Admin'}
    },
    {
      path: '/manage_assessments',
      name: 'Manage assessments',

      component: () => import(/* webpackChunkName: "about" */ '../views/ManageAssessments.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },
    {
      path: '/do_assessment/:token/:id',
      name: 'Complete assessment',

      component: () => import(/* webpackChunkName: "about" */ '../views/LicenceAssessment.vue'),
    
    },
    {
      path: '/assessment_results/:id',
      name: 'Assessment results',

      component: () => import(/* webpackChunkName: "about" */ '../views/AssessmentResults.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },
    {
      path: '/assessment_consolide_results/:id',
      name: 'Assessment consolide results',

      component: () => import(/* webpackChunkName: "about" */ '../views/AssessmentConsolideResults.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },
    {
      path: '/assements_metrics/:id',
      name: 'Assessment metrics',
      component: () => import(/* webpackChunkName: "about" */ '../views/AssementsMetrics.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },
    {
      path: '/potential_partners/:pid/:sid',
      name: 'Shortlist of potential partners',

      component: () => import(/* webpackChunkName: "about" */ '../views/PotentialPartners.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },
    {
      path: '/innopearl_assessment/:id',
      name: 'Innopearl do assessment',

      component: () => import(/* webpackChunkName: "about" */ '../views/InnoAssessment.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },
    {
      path: '/innopearl_assess_startup/:id/:sid',
      name: 'Innopearl assess the innovator',

      component: () => import(/* webpackChunkName: "about" */ '../views/InnoAssessStartup.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },
    {
      path: '/innopearl_assessment_results/:id',
      name: 'Innopearl assessment results',

      component: () => import(/* webpackChunkName: "about" */ '../views/InnopearlAssessmentResults.vue'),
      meta: {
        droit_access_required: [ "full"]
      }
    },

    {
      path: '/expert/manage_assessments',
      name: 'Expert - Manage assessments',

      component: () => import(/* webpackChunkName: "about" */ '../views/expert/ManageAssessments.vue'),
      meta: {roleRestriction: 'Expert'}
    },
    {
      path: '/admin/manage_assessments',
      name: 'Admin - Manage assessments',

      component: () => import(/* webpackChunkName: "about" */ '../views/admin/ManageAssessments.vue'),
      meta: {roleRestriction: 'Admin'}
    },
    {
      path: '/admin/internalassessment_creation/:id?',
      name: 'Admin - Create an internal assessment',

      component: () => import(/* webpackChunkName: "about" */ '../views/admin/InternalAssessmentCreation.vue'),
      meta: {roleRestriction: 'Admin'}

    },
    {
      path: '/admin/internalassessment_preview/:id',
      name: 'Admin - Preview an internal assessment',

      component: () => import(/* webpackChunkName: "about" */ '../views/InternalAssessmentPreview.vue'),
      meta: {roleRestriction: 'Admin'}

    },

    {
      path: '/admin/manage_assessments_criterias',
      name: 'Admin - Manage assessment criterias ',

      component: () => import(/* webpackChunkName: "about" */ '../views/admin/ManageCriterias.vue'),
      meta: {roleRestriction: 'Admin'}

    },

    {
      path: '/admin/manage_users_criterias',
      name: 'Admin - Manage users criterias ',

      component: () => import(/* webpackChunkName: "about" */ '../views/admin/ManageUserCriterias.vue'),
      meta: {roleRestriction: 'Admin'}

    },

    {
      path: '/admin/manage_next_steps',
      name: 'Admin - Manage next steps',

      component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminNextSteps.vue'),
      meta: {roleRestriction: 'Admin'}

    },
    {
      path: '/where_to_innovate_index',
      name: 'My AI-powered briefs',

      component: () => import(/* webpackChunkName: "about" */ '../views/WhereToInnovateIndex.vue'),
      meta: {
        droit_access_required: [ "pearlai","full","pearlai_and_scouting"]
      }
    },
    {
      path: '/where_to_innovate_finder',
      name: 'WHERE TO INNOVATE+',

      component: () => import(/* webpackChunkName: "about" */ '../views/WhereToInnovateFinder.vue'),
           meta: {
        droit_access_required: [ "pearlai","full","pearlai_and_scouting"]
      }
    },
    {
      path: '/where_to_innovate_results/:id',
      name: 'Find innovators - WHERE TO INNOVATE+',

      component: () => import(/* webpackChunkName: "about" */ '../views/WhereToInnovateResults.vue'),
           meta: {
        droit_access_required: [ "pearlai","full","pearlai_and_scouting"]
      }
    },
    {
      path: '/shared_pearlai_brief/:id',
      name: 'Shared PearlAI brief',

      component: () => import(/* webpackChunkName: "about" */ '../views/SharedPearlaiBrief.vue'),
      meta: {
        public_availability:true
      }
    },
    {
      path: '/pearlai_dataroom',
      name: 'Dataroom - WHERE TO INNOVATE+',

      component: () => import(/* webpackChunkName: "about" */ '../views/DataRoom.vue'),
           meta: {
        droit_access_required: [ "pearlai","full","scouting","pearlai_and_scouting"]
      }
    },
    {
      path: '/ranking/:id',
      name: 'My ranking space',

      component: () => import(/* webpackChunkName: "about" */ '../views/Ranking.vue'),
           meta: {
        droit_access_required: ["full","scouting","pearlai_and_scouting"]
      }
    },
    {
      path: '/rankings',
      name: 'My priority lists',

      component: () => import(/* webpackChunkName: "about" */ '../views/RankingList.vue'),
           meta: {
        droit_access_required: [ "full","scouting","pearlai_and_scouting"]
      }
    },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
      }
    }
    else{
      return { top: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
   const isAuthenticated = store.getters['authenticated']
  if(to.meta.public_availability == true)next();
  else if(to.name == "Judge assessment")next();
  else if(to.name == "Innovator Application")next();
  else if(to.name == "Judge - Assess the innovator")next();
  else if(to.name == "Manage my innovator profile")next();
  else if(to.name == "Confirm your account")next();
  else if(to.name == "Shared startup list")next();
  else if(to.name == "login")next();
  else if(to.name == "register")next();
  else if(to.name == "unauthorize")next();
  else if(to.name == "Innovator profile shared")next();
  else  if(to.name != 'unauthorize' &&  to.name != 'login' && to.name !='register' && to.name != 'Confirm your account' && !isAuthenticated) next({ name: 'login' })
   else {
  //   //if not a free route check if is removed
  //  if (to.name == 'unauthorize' || to.name == 'Judge assessment' ||  to.name == 'login' || to.name == 'register' || to.name == 'Confirm your account' || to.name == 'Startup Application' ) next();
    api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount").then( (r) => {
      console.log("MyAccoutn",r.data);
      const pearlAICredit = r.data?.PearlAICredit ?? r.data?.pearlAICredit;
      const rankAICredit = r.data?.RankAICredit ?? r.data?.rankAICredit ?? r.data?.RankAICredit ?? r.data?.rankAICredit;
      if (pearlAICredit !== undefined && pearlAICredit !== null) {
        store.commit('UPDATE_PEARLAI_CREDIT', pearlAICredit);
      }
      if (rankAICredit !== undefined && rankAICredit !== null) {
        store.commit('UPDATE_RANKAI_CREDIT', rankAICredit);
      }
      if(r.data?.droit_access_platform){
        store.commit('UPDATE_DROIT_ACCESS_PLATFORM',r.data.droit_access_platform);
      }
      // Continue the navigation checks, parameterized by the subscription gate.
      const proceed = (gated) => {
        // Subscription gate: invalid subscription (post-grace) → confine the user
        // to My Account + the upgrade flow. Computed server-side (resolves to the
        // Responsable for sub-accounts); never true for users without a subscription.
        if (gated && !SUBSCRIPTION_ALLOWED_ROUTES.includes(to.name)) {
          toast.error("Your subscription has ended. Renew your plan to regain access to the platform.");
          return next({ name: 'Upgrade your plan' });
        }
         var loginFrom = store.getters['loginFrom'];
         console.log("loginFrom",loginFrom);
         console.log("typeof loginFrom'",typeof loginFrom);
         if(loginFrom != 'undefined' && loginFrom != null){
           api.get(process.env.VUE_APP_API_URL+"/restrict/info_from/"+loginFrom).then( (r) => {
             console.log("from data ;",r.data);
             if(r.data.forceRelogin){
                 next({ name: 'login' });
             }
           });
         }
      // if(r.data.forceRelogin){
      //     next({ name: 'login' });
      // }
      // Skip the licence-expiry → login bounce for gated subscription users:
      // their licence is expired *because* the subscription ended, and they are
      // already confined to My Account + the upgrade flow above.
      if(r.data.licence_end && !gated){

        var today = new Date();
        var licence_end = new Date(r.data.licence_end.date);
        if(today > licence_end){
          toast.error("Your license has expired. Please contact us to renew or extend your access.");
          next({ name: 'login' });
        }
      }
      if(r.data.licence_start){

        var today3 = new Date();
        var licence_start = new Date(r.data.licence_start.date);
        if(today3 < licence_start){
          toast.error("Your licence is not active yet");
          next({ name: 'login' });
        }
      }
      if(r.data.isRemoved){
              console.log("MyAccoutn is removed",r.data);
           next({ name: 'login' });
      }
      else{


        api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {

          store.commit('UPDATE_MYPROJECTS',r.data);


          if(to.meta.roleRestriction){
            console.log("route restriction");
            console.log(to.meta.roleRestriction);
             const user_role = store.getters['role'];

             if(user_role != to.meta.roleRestriction){
                next({ name: 'unauthorize' })
             }
             else{
               const required = to.meta?.droit_access_required;
                  if (Array.isArray(required) && required.length > 0) {
                    const droit = store.getters["droit_access_platform"] ?? "full";
                    if (!required.includes(droit)) {
                      return next({ name: "unauthorize_access" });
                    }
              }
              if(isAuthenticated)store.commit('UPDATE_NOTIFICATION')
              next();
              }
          }
          else {
            // Mettre à jour le store Vuex
             const required = to.meta?.droit_access_required;
            if (Array.isArray(required) && required.length > 0) {
              const droit = store.getters["droit_access_platform"] ?? "full";
              if (!required.includes(droit)) {
                return next({ name: "unauthorize_access" });
              }
  }
            if(isAuthenticated)store.commit('UPDATE_NOTIFICATION')
            next();
        }
          }).catch( (e) => console.log(e));
      }
      };

      // Fetch the subscription gate, then run the checks. If it fails (e.g. the
      // endpoint is unreachable), behave as ungated so nothing breaks for users
      // without a subscription.
      api.get(process.env.VUE_APP_API_URL+"/restrict/subscription_gate")
        .then((g) => proceed(!!(g && g.data && g.data.gated)))
        .catch(() => proceed(false));
    }).catch( (e) => console.log(e));

   }
})


export default router
